let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("31b1q")).then(() => parcelRequire('1xC4V'));